import React, { Component } from "react";
import Btn from "../../../Components/Btn";
import EditTripPopup from './EditTripPopup';


export default class TripsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
          popupActive: null,
        };
    }

    togglePopupClasses = (event, id) => {
        event.preventDefault();
        this.setState({ popupActive: this.state.popupActive !== id ? id : null });
      };

    formatDate(string) {
        var options = { year: 'numeric', month: 'short', day: '2-digit' };
        return new Date(string).toLocaleDateString([], options);
    }
    componentWillMount() {
      document.addEventListener('keydown', e => {
        // console.log(e.keyCode);
        if (e.keyCode === 27) {
            this.props.toggleFn.toggleFn(e);
        }
      });
    }
    render() {
        let tripsArray = [];
        let trips = this.props.tripsData;
        trips.forEach(trip => {
            tripsArray.push(
                <tr>
                    <td>{trip.no}</td>
                    <td>{this.formatDate(trip.date)}</td>
                    <td>{trip.route.from} - {trip.route.to}</td>
                    <td>{trip.time.departure}</td>
                    <td className="fit-width">{trip.time.return ? trip.time.return : '_'}</td>
                    <td>
                        <div className="trip-actions">
                            <p className={trip.bookings === 0 ? '' : 'green'}>{trip.bookings} Bookings</p>
                            <div className="actions">
                                <Btn 
                                    className="btn simple"
                                    onClick={event => this.togglePopupClasses(event, trip.id)}
                                >
                                    edit
                                </Btn>
                                <Btn className="btn icon"><img src="/imgs/icons/delete.png" alt="delete icon" width="10" /></Btn>
                            </div>
                        </div>
                    </td>
                </tr>
            )
        });
        return (
            <React.Fragment>
                <table className="basic-table align-left">
                    <thead>
                        <tr>
                            <th>Trip No.</th>
                            <th>Trip Date</th>
                            <th>Route</th>
                            <th>Departure Time</th>
                            <th>Return Time</th>
                            <th>Bookings</th>
                        </tr>
                    </thead>
                    <tbody>{tripsArray}</tbody>
                </table>
                <EditTripPopup currentTrip={this.state.popupActive} tripsData={trips} toggleFn={this.togglePopupClasses}/>
            </React.Fragment>
        );
    }
}
